import React from 'react'

import './table-header-cell-group.scss'

import cn from '../../../../commons/src/libs/class-names'
import {
  countChildrenWithFragments,
  mapChildrenWithFragments,
} from '../../../../commons/src/services/react-children'
import {getCellLayout} from './utils'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import TableCell from './TableCell'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    width?: number | string
    computedWidth?: string
    align?: 'left' | 'center' | 'right'
    label?: string
    labelAlign?: 'left' | 'center' | 'right'
    firstCell?: boolean
    lastCell?: boolean
    children?: React.ReactNode
  }
>

const TableHeaderCellGroup = ({
  className,
  children,
  computedWidth: width,
  align = 'left', // children and column alignemnt
  label,
  labelAlign = align,
  firstCell = false,
  lastCell = false,
  ...props
}: Props) => {
  const {computedWidths} = getCellLayout(children)
  const childCount = countChildrenWithFragments(children)

  return (
    <div
      {...props}
      className={cn(
        'TableHeaderCellGroup',
        {
          [`labelAlign-${labelAlign}`]: !!labelAlign,
          fixed: !!width && width.includes('px'),
          firstCell,
          lastCell,
        },
        className
      )}
      style={{width}}
    >
      {label && <div className="TableHeaderCellGroup__label">{label}</div>}
      <div className="TableHeaderCellGroup__content">
        {mapChildrenWithFragments<React.ComponentProps<typeof TableCell>>(children, (child, i) =>
          React.cloneElement(child, {
            computedWidth: computedWidths[i],
            align: child.props.align || align,
            firstCell: i === 0 && firstCell,
            lastCell: i === childCount - 1 && lastCell,
          })
        )}
      </div>
    </div>
  )
}

export default TableHeaderCellGroup
